import { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';

interface iNotFoundPageProps {}

const NotFoundPage: FunctionComponent<iNotFoundPageProps> = () => {
  return (
    <div className='w-full h-full flex items-center flex-col justify-center'>
      <h1 className='text-8xl font-bold'>404</h1>
      <p className='mt-2 mb-8'>Page not found</p>
      <Link to='/' className='text-blue-500 underline'>
        Back Home
      </Link>
    </div>
  );
};

export default NotFoundPage;
